module.exports = __webpack_public_path__ + "img/unnamed@2x.0290ce18.png";